import { connect } from 'react-redux'
import { compose, graphql } from 'react-apollo'
import { createStructuredSelector } from 'reselect'

import {
  selectFilters,
  selectOrderings,
  selectOrderBy,
  selectTasteProfile,
  selectTasteProfiles,
  selectPriceRange
} from 'environments/TasteProfileOnboarding/selectors'
import {
  toggleFilter,
  toggleFilterExpansion,
  updatePriceFilter,
  setOrderBy,
  clearAllFilters
} from 'environments/TasteProfileOnboarding/actions'
import { productsQuery } from 'environments/TasteProfileOnboarding/queries'
import {
  PRICE_FILTER,
  TASTE_PROFILE_FILTER,
  ORDER_BY_FILTER,
  COUNTRY_FILTER
} from 'constants/filtering'
import {
  RED_LABEL_NL
} from 'constants/wines'
import { WineList } from './WineList'

export const PAGINATE_BY = 20

const mapStateToProps = createStructuredSelector({
  filters: selectFilters,
  orderings: selectOrderings,
  orderBy: selectOrderBy,
  tasteProfile: selectTasteProfile,
  tasteProfiles: selectTasteProfiles,
  priceRange: selectPriceRange
})

const clearGetParams = ({ router }) => {
  const { location } = router
  const { pathname, query } = location
  const targetQuery = {}

  // only reset the get param if its the default (red wine)
  if (
    query[TASTE_PROFILE_FILTER.GET_PARAM] &&
       query[TASTE_PROFILE_FILTER.GET_PARAM] !== RED_LABEL_NL) {
    targetQuery[TASTE_PROFILE_FILTER.GET_PARAM] = query[TASTE_PROFILE_FILTER.GET_PARAM]
  }
  if (
    query[ORDER_BY_FILTER.GET_PARAM] &&
       query[ORDER_BY_FILTER.GET_PARAM] !== ORDER_BY_FILTER.OPTIONS[0].value) {
    targetQuery[ORDER_BY_FILTER.GET_PARAM] = query[ORDER_BY_FILTER.GET_PARAM]
  }
  router.push({
    query: targetQuery,
    pathname
  })
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleFilterSelect: (name, value, tasteProfiles) => {
    const { router } = ownProps
    if (name === PRICE_FILTER.NAME) {
      return dispatch(updatePriceFilter({ value, router }))
    } else if (name === ORDER_BY_FILTER.NAME) {
      return dispatch(setOrderBy(name, value, router))
    }
    let allowMultiple = false
    if (name === COUNTRY_FILTER.NAME) {
      allowMultiple = true
    }
    return dispatch(toggleFilter({ name, value, router, tasteProfiles, allowMultiple }))
  },
  handleClickToggleExpansion: (filter) => dispatch(toggleFilterExpansion(filter)),
  clearAllFilters: () => {
    clearGetParams(ownProps)
    // Because the new render is done before clearGetParams is done (after new frame)
    // the new render would use the old props. This is prevented by getAnimationFrame
    requestAnimationFrame(() => dispatch(clearAllFilters()))
  }
})

export const getOptions = ({ ...props }) => {
  const { tasteProfile, priceRange, orderBy, filters } = props
  const countryFilter = filters.find((filter) => filter.name === COUNTRY_FILTER.NAME)
  const selectedCountries = countryFilter && countryFilter.options.filter((option) => option.selected)
  const selectedCountryNames = selectedCountries && selectedCountries.map((option) => option.value)

  return {
    fetchPolicy: 'network-only',
    variables: {
      limit: PAGINATE_BY,
      ...tasteProfile,
      ...priceRange,
      orderBy,
      countrySlug: selectedCountryNames
    }
  }
}

const getProps = ({ data, ownProps }) => {
  const { fetchMore } = data
  const { tasteProfile, priceRange, orderBy } = ownProps
  return {
    data: { ...data },
    loadMore: () => {
      const { endCursor: after } = data.products.pageInfo
      return fetchMore({
        query: productsQuery,
        variables: {
          limit: PAGINATE_BY,
          ...tasteProfile,
          ...priceRange,
          orderBy,
          after
        },
        updateQuery: (result, { fetchMoreResult }) => ({
          products: {
            edges: [...result.products.edges, ...fetchMoreResult.products.edges],
            pageInfo: {
              hasPreviousPage: fetchMoreResult.products.pageInfo.hasPreviousPage,
              hasNextPage: fetchMoreResult.products.pageInfo.hasNextPage,
              startCursor: result.products.pageInfo.startCursor,
              endCursor: fetchMoreResult.products.pageInfo.endCursor,

              // eslint-disable-next-line no-underscore-dangle
              __typename: fetchMoreResult.products.pageInfo.__typename
            },
            totalCount: fetchMoreResult.products.totalCount,
            // eslint-disable-next-line no-underscore-dangle
            __typename: fetchMoreResult.products.__typename
          }
        })
      })
    }
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  graphql(productsQuery, {
    options: getOptions,
    props: getProps
  })
)(WineList)
